import Radio from 'backbone.radio';
import DeviceSettingsDialog from '@/views/dialogs/device_settings';

    var globalCh = Radio.channel('global');

    export default function show_device_settings_dialog(model){
        model.load().then(function(){
            model.rel.load_all().done(function(){
                // This insanity is warranted because load_all() can't be trusted to 
                // actually load everything. Caleb spent 3 hours trying to figure out 
                // why this is the case and failed. 
                // Furthermore, the templateContext function of a view runs on instantiation,
                // hence needing to seperately instantiate it in each case.
                if (!model.rel.get('devicegroup')) {
                    let view = new DeviceSettingsDialog({ model: model });
                    globalCh.request('showDialog', view);
                } else if (!model.rel.get('devicegroup').is_loaded()) {
                    model.rel.get('devicegroup').load().done(function(){
                        let view = new DeviceSettingsDialog({ model: model });
                        globalCh.request('showDialog', view);
                    });
                } else {
                    let view = new DeviceSettingsDialog({ model: model});
                    globalCh.request('showDialog', view);
                }
            });
        });
    }

